import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../../../shared/utils/helpers';

const ExportDeliverablesMutation = input =>
  new Promise((resolve, reject) => {
    commitMutation(getEnvironment(), {
      mutation: graphql`
        mutation ExportDeliverablesMutation($input: ExportDeliverablesInput!) {
          exportDeliverables(input: $input) {
            fileUrl
          }
        }
      `,
      variables: { input },
      onCompleted: resolve,
      onError: reject
    });
  });

export default ExportDeliverablesMutation;
